import { appstr } from "@coreapp/utils/appstr";
import { Alert } from "@theorgchartdev/storybook";
import cx from "classnames";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumPlanStatus, enumUIModes } from "@coreapp/constants";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";

interface PlanStatusAlertProps {
  className?: string;
  planStatus: (typeof enumPlanStatus)[keyof typeof enumPlanStatus];
}

const PlanStatusAlert = ({ className, planStatus }: PlanStatusAlertProps) => {
  const { dismissPlanStatusAlert, isPlanStatusAlertDismissed } = usePlanManagerContext();

  if (isPlanStatusAlertDismissed) {
    return null;
  }

  const severity = planStatus === enumPlanStatus.archived ? "info" : "warning";

  const message = appstr("This plan is locked and cannot be edited.", {
    status: appstr(planStatus).toLowerCase()
  });

  const icon = planStatus === enumPlanStatus.archived ? "box-archive" : "lock";

  return (
    <Alert
      severity={severity}
      iconOverride={icon}
      alertActions={{
        closeAction: dismissPlanStatusAlert
      }}
      className={cx("ocn-plan-locked-alert", className)}
    >
      {message}
    </Alert>
  );
};

const PlanStatusAlertWrapper = ({ className }: Pick<PlanStatusAlertProps, "className">) => {
  const currentUIMode = Globals._uiConfig?.GetUIMode();
  const isPlanningMode = currentUIMode === enumUIModes.planning;
  const { planManager } = usePlanManagerContext();
  const planStatus = planManager?.state?.GetPlanStatus();
  const showPlanStatusAlert =
    planStatus === enumPlanStatus.locked || planStatus === enumPlanStatus.archived;

  if (!isPlanningMode || !showPlanStatusAlert) {
    return null;
  }

  return <PlanStatusAlert className={className} planStatus={planStatus} />;
};

export default PlanStatusAlertWrapper;
